import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import autoTable from 'jspdf-autotable'
import { calculateDynamicFormatPortrait, calculateTotalTableWidth, focusElemnt, generateDynamicColumnStyles, navigation3 } from '../../../../common/helper'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import SummaryTable from './SummaryTable'
import SummaryTableExcel from './SummaryTableExcel'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../common/font/Roboto-normal'
import { summaryColumn } from './DelFranchiseeConstant'
import jsPDF from 'jspdf'
import moment from 'moment'


const SummaryReport = ({ loginCountryId,isPdfLoading, disableExcel, loginData, setIsPdfLoading, tableData1, headerFilterData }) => {
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [tableData, setTableData] = useState(tableData1)
    useEffect(() => {
        if (tableData1.length > 0) {
            setTableData(formatData(tableData1,loginCountryId))
        }
    }, [])

    // const formatData = (dataArray) => {
    //     let formattedData = [];
    //     let paymentTypes = {};

    //     // Group data by PaymentType
    //     dataArray.forEach((data, index) => {
    //         const paymentType = data.PaymentType;
    //         if (!paymentTypes[paymentType]) {
    //             paymentTypes[paymentType] = [];
    //         }
    //         paymentTypes[paymentType].push(data);
    //     });

    //     // Process each payment type group
    //     Object.keys(paymentTypes).forEach(paymentType => {
    //         // Add subheading row
    //         formattedData.push({
    //             isSubHeadingRow: true,
    //             isSubHeadingData: [
    //                 { caption: "Payment Type: ", value: paymentType, colSpan: 13, align: 'left' }
    //             ]
    //         });

    //         // Add row data for each item in the group
    //         paymentTypes[paymentType].forEach((data, index) => {
    //             formattedData.push({
    //                 isRowData: true,
    //                 srNo: (index + 1).toString(),
    //                 PaymentType: data.PaymentType,
    //                 ItemUnits: data.ItemUnits,
    //                 FreightCharge: data.FreightCharge,
    //                 KMFreight: data.KMFreight,
    //                 BkgOthCharge: data.BkgOthCharge,
    //                 DelCart: data.DeliveryCartage,
    //                 DelHam: data.DeliveryHamali,
    //                 ExtraHameli: data.ExtraHamali,
    //                 Demurrage: data.DemurrageCharge,
    //                 DelGST: data.DeliveryGST,
    //                 DelDisc: data.DelDiscount,
    //                 NetAmount: data.NetAmount
    //             });
    //         });

    //         // Add total row for the payment type group
    //         formattedData.push({
    //             isTotalRow: true,
    //             align: "left",
    //             caption: `Total-${paymentType}`,
    //             ItemUnits: 10,
    //             FreightCharge: 100,
    //             KMFreight: 110,
    //             BkgOthCharge: 10,
    //             DelCart: 10,
    //             DelHam: 10,
    //             ExtraHameli: 10,
    //             Demurrage: 10,
    //             DelGST: 10,
    //             DelDisc: 5,
    //             NetAmount: 10
    //         });
    //     });

    //     // Add overall total row
    //     formattedData.push({
    //         isTotalRow: true,
    //         align: "left",
    //         caption: 'Total-All',
    //         ItemUnits: 10,
    //         FreightCharge: 100,
    //         KMFreight: 110,
    //         BkgOthCharge: 10,
    //         DelCart: 10,
    //         DelHam: 10,
    //         ExtraHameli: 10,
    //         Demurrage: 10,
    //         DelGST: 10,
    //         DelDisc: 5,
    //         NetAmount: 10
    //     });

    //     return formattedData;
    // }
    const formatData = (dataArray, loginCountryId) => {
        let formattedData = [];
        let paymentTypes = {};
    
        dataArray.forEach((data) => {
            const paymentType = data.PaymentType;
            if (!paymentTypes[paymentType]) {
                paymentTypes[paymentType] = [];
            }
            paymentTypes[paymentType].push(data);
        });
    
        let overallTotals = {
            ItemUnits: 0,
            FreightCharge: 0,
            KMFreight: 0,
            BkgOthCharge: 0,
            DelCart: 0,
            DelHam: 0,
            ExtraHameli: 0,
            Demurrage: 0,
            DelGST: 0,
            DelDisc: 0,
            NetAmount: 0
            
        };
    
        Object.keys(paymentTypes).forEach(paymentType => {
            formattedData.push({
                isSubHeadingRow: true,
                isSubHeadingData: [
                    { caption: "Payment Type: ", value: paymentType, colSpan: 13, align: 'left' }
                ]
            });
    
            let groupTotals = {
                ItemUnits: 0,
                FreightCharge: 0,
                KMFreight: 0,
                BkgOthCharge: 0,
                DelCart: 0,
                DelHam: 0,
                ExtraHameli: 0,
                Demurrage: 0,
                DelGST: 0,
                DelDisc: 0,
                NetAmount: 0
            };
    
            paymentTypes[paymentType].forEach((data, index) => {
                const row = {
                    isRowData: true,
                    srNo: (index + 1).toString(),
                    PaymentType: data.PaymentType,
                    ItemUnits: data.ItemUnits,
                    FreightCharge: data.FreightCharge,
                    KMFreight: data.KMFreight,
                    BkgOthCharge: data.BkgOthCharge,
                    DelCart: data.DeliveryCartage,
                    DelHam: data.DeliveryHamali,
                    ExtraHameli: data.ExtraHamali,
                    Demurrage: data.DemurrageCharge,
                    DelDisc: data.DelDiscount,
                    NetAmount: data.NetAmount
                };
    
                if (loginCountryId !== 2) {
                    row.DelGST = data.DeliveryGST;
                }
    
                formattedData.push(row);
    
                groupTotals.ItemUnits += data.ItemUnits;
                groupTotals.FreightCharge += data.FreightCharge;
                groupTotals.KMFreight += data.KMFreight;
                groupTotals.BkgOthCharge += data.BkgOthCharge;
                groupTotals.DelCart += data.DeliveryCartage;
                groupTotals.DelHam += data.DeliveryHamali;
                groupTotals.ExtraHameli += data.ExtraHamali;
                groupTotals.Demurrage += data.DemurrageCharge;
                groupTotals.DelDisc += data.DelDiscount;
                groupTotals.NetAmount += data.NetAmount;
    
                if (loginCountryId !== 2) {
                    groupTotals.DelGST += data.DeliveryGST;
                }
            });
    
            const totalRow = {
                isTotalRow: true,
                align: "left",
                caption: `Total-${paymentType}`,
                ItemUnits: groupTotals.ItemUnits.toFixed(2),
                FreightCharge: groupTotals.FreightCharge.toFixed(2),
                KMFreight: groupTotals.KMFreight.toFixed(2),
                BkgOthCharge: groupTotals.BkgOthCharge.toFixed(2),
                DelCart: groupTotals.DelCart.toFixed(2),
                DelHam: groupTotals.DelHam.toFixed(2),
                ExtraHameli: groupTotals.ExtraHameli.toFixed(2),
                Demurrage: groupTotals.Demurrage.toFixed(2),
                DelDisc: groupTotals.DelDisc.toFixed(2),
                NetAmount: groupTotals.NetAmount.toFixed(2)
            };
    
            if (loginCountryId !== 2) {
                totalRow.DelGST = groupTotals.DelGST.toFixed(2);
            }
    
            formattedData.push(totalRow);
    
            overallTotals.ItemUnits += groupTotals.ItemUnits;
            overallTotals.FreightCharge += groupTotals.FreightCharge;
            overallTotals.KMFreight += groupTotals.KMFreight;
            overallTotals.BkgOthCharge += groupTotals.BkgOthCharge;
            overallTotals.DelCart += groupTotals.DelCart;
            overallTotals.DelHam += groupTotals.DelHam;
            overallTotals.ExtraHameli += groupTotals.ExtraHameli;
            overallTotals.Demurrage += groupTotals.Demurrage;
            overallTotals.DelDisc += groupTotals.DelDisc;
            overallTotals.NetAmount += groupTotals.NetAmount;
    
            if (loginCountryId !== 2) {
                overallTotals.DelGST += groupTotals.DelGST;
            }
        });
    
        const overallTotalRow = {
            isTotalRow: true,
            align: "left",
            caption: 'Total-All',
            ItemUnits: overallTotals.ItemUnits.toFixed(2),
            FreightCharge: overallTotals.FreightCharge.toFixed(2),
            KMFreight: overallTotals.KMFreight.toFixed(2),
            BkgOthCharge: overallTotals.BkgOthCharge.toFixed(2),
            DelCart: overallTotals.DelCart.toFixed(2),
            DelHam: overallTotals.DelHam.toFixed(2),
            ExtraHameli: overallTotals.ExtraHameli.toFixed(2),
            Demurrage: overallTotals.Demurrage.toFixed(2),
            DelDisc: overallTotals.DelDisc.toFixed(2),
            NetAmount: overallTotals.NetAmount.toFixed(2)
        };
    
        if (loginCountryId !== 2) {
            overallTotalRow.DelGST = overallTotals.DelGST.toFixed(2);
        }
    
        formattedData.push(overallTotalRow);
    
        return formattedData;
    };
    

    const filterData = {
        FranchiseCompany: headerFilterData?.FranchiseCompany,
        FranchiseeDelCity: headerFilterData?.FranchiseeDelCity,
        FranchiseeDelBranch: headerFilterData?.FranchiseeDelBranch,
        OwnBookingCity: headerFilterData?.OwnBookingCity,
        OwnBookingBranch: headerFilterData?.OwnBookingBranch,
        OwnBookingBranchUser: headerFilterData?.OwnBookingBranchUser,
        PaymentType: headerFilterData?.PaymentType,
        PaymentMode: headerFilterData?.PaymentMode,
        ReportView: "Summary",
        FromDate: headerFilterData?.FromDate,
        ToDate: headerFilterData?.ToDate
    }
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        const widthCell = calculateTotalTableWidth(summaryColumn)
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
        const doc = new jsPDF({ orientation: 'p', format: calculateDynamicFormatPortrait((widthCell) + 60), unit: 'px', compress: true })
        doc.setProperties({
            title: `Franchisee Deliveries Summary.pdf`,
            subject: 'Franchisee Deliveries Summary Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, LRWise',
            creator: 'MTLPL',
        })
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / 793;
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 200, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }

        const HeaderColumns = [
            { header: 'Franchise Company', dataKey: "FranchiseCompany", xlCol: { dataType: 'string' } },
            { header: 'Franchisee Del. City', dataKey: "FranchiseeDelCity", xlCol: { dataType: 'string' } },
            { header: 'Franchisee Del. Branch', dataKey: "FranchiseeDelBranch", xlCol: { dataType: 'string' } },
            { header: 'Own Booking City', dataKey: "OwnBookingCity", xlCol: { dataType: 'string' } },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
                doc.text(`Delivery Date: ${filterData.FromDate} to ${filterData.ToDate}`, data.settings.margin.left, 150)
                doc.text(`Report: Franchisee Deliveries`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
            showHead: "firstPage",
        })

        const HeaderColumns1 = [
            { header: 'Own Booking Branch', dataKey: "OwnBookingBranch", xlCol: { dataType: 'string' } },
            { header: 'Own Booking Branch User', dataKey: "OwnBookingBranchUser", xlCol: { dataType: 'string' } },
            { header: 'Payment Type', dataKey: "PaymentType", xlCol: { dataType: 'string' } },
            { header: 'Payment Mode', dataKey: "PaymentMode", xlCol: { dataType: 'string' } },
            { header: 'Report View', dataKey: "ReportView", xlCol: { dataType: 'string' } },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns1,
            body: [filterData],
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,

            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                4: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            },
            showHead: "firstPage",
        })

        let pdfColumns = summaryColumn.filter(col => !(loginCountryId === 2 && col.field === 'DelGST')).map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isSubHeadingRow) {
                    if (val.raw.isSubHeadingData.length > 0) {
                        let prevColSpan = 0;
                        val.raw.isSubHeadingData.map((obj, index) => {
                            val.cells[prevColSpan].text = `${obj.caption}${obj.value}`;
                            val.cells[prevColSpan].colSpan = obj.colSpan
                            val.cells[prevColSpan].styles.font = 'Roboto'
                            val.cells[prevColSpan].styles.halign = obj.align
                            prevColSpan += obj.colSpan
                        })
                    }
                } else if (val.raw.isTotalRow) {
                    let prevColSpan = 0;
                    for (let key in val.raw) {
                        if (key == 'caption') {
                            val.cells[prevColSpan].text = val.raw.caption.toString();
                            val.cells[prevColSpan].colSpan = 2;
                            val.cells[prevColSpan].styles.halign = val.raw.align
                            prevColSpan += 2;
                        }
                        else {
                            if (key !== 'isTotalRow' && key !== 'colSpan' && key !== 'align') {
                                val.cells[prevColSpan].text = Number(val.raw[key]).toFixed();
                                prevColSpan += 1;
                            }
                        }
                    }
                } else if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = summaryColumn.length;
                    val.cells[0].styles.halign = 'center'
                }

            })
        }
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: tableData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: generateDynamicColumnStyles(summaryColumn, scaleFactor * 12),
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                font: 'Roboto',
                fontStyle: 'normal'
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            willDrawCell: (data) => {
                if (data.row.raw.isSubHeadingRow) {
                    doc.setFillColor(241, 249, 255);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                } else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(scaleFactor * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System |  Delivery Reports', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Franchisee Deliveries Summary.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            document.getElementById('output').data = doc.output('datauristring', 'Franchisee Deliveries Summary.pdf')
            focusElemnt('backBtn')
        }, 2000)
    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', paddingTop: '2px' }}>
                <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                    Report For: Franchisee Deliveries Report
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                {disableExcel ?
                                    <Button variant="outlined" sx={{ width: '100%' }} disabled={true} className="receiveitembtn">
                                        Export to Excel
                                    </Button>
                                    :
                                    <div
                                        onKeyDown={(e) => {
                                            navigation3(e, "exportPdf", id.reportmainButton, () => { })
                                        }}
                                    >
                                        <ReactHtmlTableToExcel
                                            id="exportExcelBtn"
                                            className="receiveitemExcelBtn"
                                            table="DeliveryFranchiseeSummary"
                                            filename="Delivery Franchisee Summary Report"
                                            sheet="tablexls"
                                            buttonText="Export to Excel"
                                        />
                                    </div>
                                }
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"exportPdf"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", disableExcel ? id.reportmainButton : "exportExcelBtn", () => { })
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}
                                >
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={'printBtn'} sx={{ width: '100%' }}
                                    onKeyDown={(e) => {
                                        navigation3(e, id.selectCompnay, "exportPdf", () => { })
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }}
                                    className="receiveitembtn">
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }}
                                onKeyDown={(e) => {
                                    navigation3(e, id.selectCompnay, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}
                                className="receiveitembtn">
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?
                <Box sx={{ ...sx.reportFlex }}>
                    <SummaryTable tableData={tableData} loginCountryId={loginCountryId}/>
                    <SummaryTableExcel loginCountryId={loginCountryId} tableData={tableData} loginData={loginData} headerData={{
                        FranchiseCompany: headerFilterData?.FranchiseCompany,
                        FranchiseeDelCity: headerFilterData?.FranchiseeDelCity,
                        FranchiseeDelBranch: headerFilterData?.FranchiseeDelBranch,
                        OwnBookingCity: headerFilterData?.OwnBookingCity,
                        OwnBookingBranch: headerFilterData?.OwnBookingBranch,
                        OwnBookingBranchUser: headerFilterData?.OwnBookingBranchUser,
                        PaymentType: headerFilterData?.PaymentType,
                        PaymentMode: headerFilterData?.PaymentMode,
                        FromDate: headerFilterData?.FromDate,
                        ToDate: headerFilterData?.ToDate
                    }} />

                </Box> :
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center', height: '55vh' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            title="MTLPL -Cargo System - Franchisee Deliveries Report"
                            aria-label="MTLPL -Cargo System - Franchisee Deliveries Report"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>
            }
        </>
    )
}

export default SummaryReport